import styled from "styled-components";
import { theme } from "../../styles/theme";

export const NotificationsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 74px;
  background: ${theme.colors.light} 0% 0% no-repeat padding-box;
  border: 1px solid ${theme.colors.light3};
  border-radius: 18px;
  padding: 14px 16px 14px 26px;
  gap: 8px;

  @media (max-width: ${theme.breakpoints.sm}) {
    min-height: 90px;
  }
`;

export const Bullet = styled.div`
  width: 6px;
  height: 6px;
  background: ${theme.colors.salmon} 0% 0% no-repeat padding-box;
  opacity: 1;
  border-radius: 50%;
`;

export const NotificationsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 36px 0 0 0;
  width: 100%;
  overflow-y: auto;
  max-height: 280px;
  
  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
  
  /* Webkit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: transparent;
  }
`;
